import { getMomentDate } from '../utils/commonUtils';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class SaleReport {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.totalRevenue = data.totalRevenue || 0;
        this.totalOrder = data.totalOrder || 0;
        this.voucherOrders = data.voucherOrders || 0;
        this.tourOrders = data.tourOrders || 0;
        this.flightOrders = data.flightOrders || 0;
        this.hotelOrders = data.hotelOrders || 0;
        this.vinWonderOrders = data.vinWonderOrders || 0;
        this.setSaleReportItems(data.saleReportItems || {});
    }

    setSaleReportItems(data={}){
        this.saleReportItems = {
            pageIndex: data.pageIndex || PAGINATION.pageIndex,
            pageSize: data.pageSize || PAGINATION.pageSize,
            totalCount: data.totalCount || 0,
            totalPage: Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize)),
            startDate: data.startDate ? moment.utc(data.startDate) : moment.utc().startOf('isoWeeks'),
            endDate: data.startDate ? moment.utc(data.endDate) : moment.utc().endOf('days'),
            orderBy: data.orderBy,
            orderByDesc: data.orderByDesc,
            items: data.result && data.result.map(item => new SaleReportItem(item))
        }
    }

}

export class SaleReportItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.createdDate = getMomentDate(data.createdDate);
        this.revenue = data.revenue || 0;
        this.orderCount = data.orderCount || 0;
        this.voucherOrders = data.voucherOrders || 0;
        this.tourOrders = data.tourOrders || 0;
        this.flightOrders = data.flightOrders || 0;
        this.hotelOrders = data.hotelOrders || 0;
        this.vinWonderOrders = data.vinWonderOrders || 0;
    }
}